import { PublicOfferContent, PublicOfferInfo, PublicOfferInfoTitle, PublicOfferTitle, Wrapper } from "./style";

export const PublicOffer = () => {
  return (
    <Wrapper>
      <PublicOfferTitle>СОГЛАШЕНИЕ ПУБЛИЧНОЙ ОФЕРТЫ</PublicOfferTitle>

      <PublicOfferInfo>
        <PublicOfferContent>
          BILETONLINE — Общество с ограниченной ответственностью "BILETONLINE", Исполнитель.
        </PublicOfferContent>

        <PublicOfferContent>
          Пользователь — дееспособное физическое лицо, достигшее 18 лет, имеющее законное право вступать в договорные
          отношения с BILETONLINE, в том числе размещать Заказ или бронировать услуги на сайте{" "}
          <a href="https://aviabozor.uz" target="_blank" rel="noreferrer">
            https://aviabozor.uz
          </a>
          , либо указанное в качестве получателя услуги, либо иным образом пользующееся услугами, приобретенными на
          сайте{" "}
          <a href="https://aviabozor.uz" target="_blank" rel="noreferrer">
            https://aviabozor.uz
          </a>
          , исключительно для личных, домашних и иных нужд, не связанных с осуществлением предпринимательской
          деятельности.
        </PublicOfferContent>

        <PublicOfferContent>
          Сайт — веб-сайт Онлайн Трэвел в сети интернет, расположенный по адресу{" "}
          <a href="https://aviabozor.uz" target="_blank" rel="noreferrer">
            https://aviabozor.uz
          </a>
          , на котором осуществляется оформление Заказа Пользователем.
        </PublicOfferContent>

        <PublicOfferContent>
          Заказ — должным образом, оформленный запрос Пользователя на получение услуг, выбранных на Сайте.
        </PublicOfferContent>

        <PublicOfferContent>
          Электронный пассажирский билет — документ, используемый для удостоверения договора перевозки пассажира, в
          котором информация о перевозке пассажира представлена в электронно-цифровой форме. Пассажиру предоставляется в
          виде маршрутной квитанции электронного билета.
        </PublicOfferContent>

        <PublicOfferContent>
          Пользовательский счет — персональный счет Пользователя в BILETONLINE, на который производится зачисление
          денежных средств в случае возврата или отказа Пользователя от ранее оплаченного им Заказа. Указанные денежные
          средства могут быть использованы в качестве предоплаты за последующие Заказы Пользователя у BILETONLINE или
          возвращены Пользователю в порядке, предусмотренном настоящим Договором.
        </PublicOfferContent>

        <PublicOfferContent>
          Система бронирования — информационная система, содержащая сведения о расписании авиарейсов, наличии мест на
          авиарейсы, тарифах авиаперевозчиков и правилах их применения, а также другие условия оказания предлагаемых
          услуг. Указанная информация размещается на сайте{" "}
          <a href="https://aviabozor.uz" target="_blank" rel="noreferrer">
            https://aviabozor.uz
          </a>{" "}
          в полном соответствии с тем, как она представлена в системах бронирования непосредственными поставщиками
          данных услуг (авиаперевозчиками) или их полномочными представителями. Информация в системе бронирования может
          в любой момент быть изменена или дополнена, в связи с этим Пользователю предлагается использовать систему
          бронирования в режиме «ОНЛАЙН».
        </PublicOfferContent>

        <PublicOfferContent>
          Оператор — сотрудник BILETONLINE, обрабатывающий Заказы Пользователей, требующие индивидуальной «ручной»
          обработки.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>1. ОБЩИЕ ПОЛОЖЕНИЯ</PublicOfferInfoTitle>

        <PublicOfferContent>
          1.1. Сайт предназначен для поиск и получения информации по выбранному направлению на рейсы Авиакомпаний
          согласно заключенных соглашений и действует в соответствии с:
        </PublicOfferContent>

        <PublicOfferContent>
          — Законом Республики Узбекистан "ОБ ЭЛЕКТРОННОЙ КОММЕРЦИИ" № 613-II от 29 апреля 2004 г.;
        </PublicOfferContent>

        <PublicOfferContent>
          — Законом Республики Узбекистан от 22 мая 2015 года № ЗРУ-385 "О внесении изменений и дополнений в Закон
          Республики Узбекистан «Об электронной коммерции»;
        </PublicOfferContent>

        <PublicOfferContent>
          — Постановлением Кабинета Министров Республики Узбекистан "О мерах по реализации Закона Республики Узбекистан
          от 22 мая 2015 г. № ЗРУ-385 «О внесении изменений и дополнений в Закон Республики Узбекистан «Об электронной
          коммерции»;
        </PublicOfferContent>

        <PublicOfferContent>
          — Действующим Законодательством и нормативными актами Республики Узбекистан.
        </PublicOfferContent>

        <PublicOfferContent>
          — Утвержденными Правилами, инструкциями и иными нормативными документами Перевозчиков.
        </PublicOfferContent>

        <PublicOfferContent>
          1.2. В соответствии с пунктом 2 статьи 369 Гражданского кодекса Республики Узбекистан (ГК Республики
          Узбекистан) в случае принятия изложенных ниже условий - ознакомление и согласие с правилами, Тарифами и
          Таксами Перевозчиков и правилами поставщиков дополнительны услуг, свои право- и дееспособность, финансовую
          состоятельность, наличие предусмотренных законом полномочий для заключения настоящего Соглашения, оформления
          Электронных авиабилетов и совершения оплаты в пользу третьих лиц, а также сознаёт ответственность за
          обязательства, возложенные на него в результате заключения настоящего Соглашения.
        </PublicOfferContent>

        <PublicOfferContent>
          Пользователь – физическое лицо, производящий акцепт настоящей оферты, становится Заказчиком (в соответствии с
          частью 4 статьи 370 ГК Республики Узбекистан акцепт оферты равносилен заключению договора на условиях,
          изложенных в оферте), а Исполнитель и Пользователь совместно – Сторонами настоящего договора.
        </PublicOfferContent>

        <PublicOfferContent>
          1.3. Исполнитель оказывает Пользователю услуги предоставления, предусмотренной функционалом Сайта информации,
          бронировании и оформлении Электронных авиабилетов в соответствии с заданными Пользователем параметрами (дата,
          время, маршрут и иные условия перевозки), по оформлению процедуры возврата и обмена Электронных авиабилетов в
          порядке, предусмотренном настоящим Соглашением, а также дополнительных услуг доступных на странице оформления
          Электронных авиабилетов. Пользователь обязуется использовать Сайт только в случае реальной необходимости в
          бронировании и оформлении Электронных авиабилетов. В случае несоблюдения Пользователем условий настоящего
          Соглашения его доступ к Сайту может быть заблокирован.
        </PublicOfferContent>

        <PublicOfferContent>
          1.4. Исполнитель не несет ответственности по соглашениям между Пользователем и Перевозчиком, заключенным с
          использованием Сайта. В частности, Исполнитель лишь обеспечивает возможность реализации бронирования,
          оформления, возврата и обмена Электронных авиабилетов, но обязательственные отношения возникают
          непосредственно между Пользователем/лицами, в пользу которых оформлены Электронные авиабилеты и Перевозчиком.
          Оформленные Пользователем услуги Перевозчика на осуществление авиаперевозки регулируются Правилами перевозчика
          с учётом возможных изменений. Регулярное ознакомление с действующей редакцией Правил Перевозчика является
          обязанностью Пользователя.
        </PublicOfferContent>

        <PublicOfferContent>
          1.5. Вся информация, касающаяся расписания, наличия мест, Тарифов и правил их применения, Такс, а также других
          условий предоставления предлагаемых услуг доступны посредством Платформы в полном соответствии с тем, как она
          представлена в системе бронирования непосредственными поставщиками данных услуг или их уполномоченными
          представителями. Исполнитель, несмотря на компетентность, не имеет возможности производить тотальную
          независимую проверку предоставляемой поставщиками услуг информации, и не может гарантировать полное отсутствие
          неточностей в ней, в связи с чем не несет перед Пользователем ответственности за любые ошибочные данные об
          услугах, равно как и за причиненный Пользователю вред или убытки из-за наличия ошибок в информации.
        </PublicOfferContent>

        <PublicOfferContent>
          1.6. Все предложения, цены, а также условия оформления Электронных авиабилетов могут быть изменены без
          уведомления Пользователя, ограничены по времени, наличию мест и срокам предварительного заказа, датам
          путешествия, срокам минимального или максимального пребывания в месте назначения, факторами выходных дней и
          праздников, сезонным колебаниям цен, листам ожидания, а также забастовками и временной неработоспособностью
          систем бронирования и/или подвержены другим изменениям, условиям и ограничениям.
        </PublicOfferContent>

        <PublicOfferContent>
          1.7. Исполнитель оставляет за собой право в любой момент вносить изменения в настоящее Соглашение без
          направления специального уведомления. Новая редакция Соглашения вступает в силу незамедлительно после
          размещения таковой в соответствующем разделе Сайта, если прямо не предусмотрено иное. Регулярное ознакомление
          с действующей редакцией Соглашения является обязанностью Пользователя.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>2. ОФОРМЛЕНИЕ И ОПЛАТА ЗАКАЗА</PublicOfferInfoTitle>

        <PublicOfferContent>
          2.1. Заказ оформляется Пользователем самостоятельно посредством Сайта путём заполнения соответствующих форм.
          Со всеми условиями Заказа Пользователь знакомится в процессе бронирования.
        </PublicOfferContent>

        <PublicOfferContent>
          2.2. При использовании Сайта, получении доступа в Личный кабинет и последующем использовании функционала Сайта
          Пользователь обязуется: обновлять регистрационные и другие персональные данные в случае изменения таковых;
          предоставить актуальный номер телефона и адрес электронной почты для экстренной связи; обеспечивать
          сохранность и конфиденциальность логина и пароля; нести полную ответственность за любые действия, совершенные
          Пользователем с использованием своего Личного кабинета.
        </PublicOfferContent>

        <PublicOfferContent>
          2.3. При оформлении бронирования для проверки цены или в иных целях, при наличии оформленных Электронных
          авиабилетов или брони на аналогичных пассажиров и аналогичные даты, Перевозчик может расценивать это как
          дубликат. Перевозчик вправе применять различную политику в отношении двойного бронирования и оставляет за
          собой право полностью аннулировать одну или все брони.
        </PublicOfferContent>

        <PublicOfferContent>
          2.4. Оформленные Пользователем Заказы носят окончательный характер. Сразу же после поступления от Пользователя
          оформленного Заказа и оплаты, Исполнитель оформляет или обеспечивает оформление Электронных авиабилетов.
          Подтверждением оформления Заказа является направленные на указанный электронный адрес письмо- подтверждение с
          маршрутными квитанциями.
        </PublicOfferContent>

        <PublicOfferContent>
          2.5. Заказ оплачивается одним из способов, предложенных посредством Сайта. Прием платежей осуществляется с
          использованием платежных систем, которые вправе отказать в проведении платежа.
        </PublicOfferContent>

        <PublicOfferContent>
          2.6. За услуги по оформлению Электронных авиабилетов, а также за их возврат и обмен Исполнитель взимает с
          Пользователя Сбор. Сбор за оформление Электронного авиабилета включается в стоимость Заказа, штрафа. Размер
          Сбора за оформление составляет 100 000 (сто тысяч) сум за каждый сегмент авиаперелета за пассажира.
        </PublicOfferContent>

        <PublicOfferContent>
          2.7. В соответствии с действующим законодательством операции по банковским картам совершаются держателем карты
          либо уполномоченным им лицом.
        </PublicOfferContent>

        <PublicOfferContent>
          2.8. Пользователь самостоятельно несёт ответственность перед банком и любыми иными лицами в полном объёме за
          безналичные платежи, производимые Пользователем с целью оплаты Заказа, и определяемые банком как Фрод.
        </PublicOfferContent>

        <PublicOfferContent>
          2.9. Собственником мест до оформления Электронного авиабилета является Перевозчик, который оставляет за собой
          право снимать места, переносить рейсы и менять расписание и стоимость. Рекомендуем оформлять Электронный
          авиабилет одновременно с бронированием во избежание изменения цены.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>3. ВОЗВРАТ И ОБМЕН</PublicOfferInfoTitle>

        <PublicOfferContent>
          3.1. Возврат и обмен Электронных авиабилетов осуществляется одним из следующих способов: через Личный кабинет
          или посредством направления сообщения по электронной почте. Срок обработки может достигать 24 часа с момента
          получения соответствующего Запроса.
        </PublicOfferContent>

        <PublicOfferContent>
          3.2. При оплате Заказа банковской картой непосредственно Исполнителю в случае возврата Пользователем
          Электронного авиабилета, стоимость Заказа, за вычетом фактических расходов Исполнителя, перечисляется
          Пользователю на его банковскую карту. Сбор за оформление Электронных авиабилетов в случае возврата такового не
          подлежит возврату Пользователю. В случае вынужденного возврата (отмена рейса, подтвержденная Перевозчиком,
          болезнь или смерть пассажира и т.д.), Сбор за возврат билета не взимается.
        </PublicOfferContent>

        <PublicOfferContent>
          3.3. В том случае, когда поездка пассажира в результате непредвиденных обстоятельств заканчивается (или он
          делает остановку) не в стране убытия, могут быть применены нормы Варшавской Конвенции.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>4. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ</PublicOfferInfoTitle>

        <PublicOfferContent>
          4.1. Пассажир принимает на себя всю ответственность за подготовку всех необходимых документов для поездки.
          Исполнитель не несет ответственность за негативные последствия и убытки, возникшие в результате событий и
          обстоятельств, находящихся вне сферы его компетенции, в частности: за действия Перевозчика; за действия
          таможенных и иммиграционных властей; за действия консульств иностранных государств; за неявку или опоздание
          Пользователя на рейс и т.д.
        </PublicOfferContent>

        <PublicOfferContent>
          4.2. Стороны освобождаются от ответственности за ненадлежащее исполнение или неисполнение обязательств по
          настоящему Договору в случае наступления обстоятельств непреодолимой силы: пожар, эпидемия, землетрясение,
          террористический акт, наводнение, ураган, военные действия, забастовки, введение чрезвычайного положения,
          эмбарго и прочие обстоятельства, на которые стороны не могут повлиять и предотвратить.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>5. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</PublicOfferInfoTitle>

        <PublicOfferContent>
          5.1. Настоящее Соглашение регулируется и подлежит толкованию в соответствии с законодательством Республики
          Узбекистан.
        </PublicOfferContent>

        <PublicOfferContent>
          5.2. В случае возникновения любых споров или разногласий, Пользователь и Исполнитель приложат все усилия для
          их разрешения путем переговоров. До предъявления иска сторона обязана направить другой Стороне письменную
          претензию. Сторона, получившая претензию, обязана рассмотреть её и дать письменный мотивированный ответ в
          течение 10 (десяти) рабочих дней. В случае неполучения ответа Заинтересованная сторона вправе обратиться в
          Хозяйственный суд города Ташкента.
        </PublicOfferContent>

        <PublicOfferContent>
          5.3. Признание отдельных частей настоящего Соглашения недействительными не отменяет действие других положений
          настоящего Соглашения.
        </PublicOfferContent>

        <PublicOfferContent>
          5.4. Исполнитель не несет ответственности за невозможность оформления Пользователем Заказа по причинам
          нарушения работы линий связи, неисправность оборудования Пользователя и т.п.
        </PublicOfferContent>

        <PublicOfferContent>
          5.5. Пользователь принимает условия Договора и подтверждает итоговую сумму к оплате, включая все налоги и
          сборы, в том числе сборы BILETONLINE.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>Реквизиты Исполнителя</PublicOfferInfoTitle>

        <PublicOfferContent>Общество с ограниченной ответственностью «BILETONLINE»</PublicOfferContent>
        <PublicOfferContent>Юридический адрес: город Ташкент, улица Нукус, дом 88/1</PublicOfferContent>
        <PublicOfferContent>
          Фактический адрес: 100015, Республика Узбекистан, город Ташкент, улица Хонзодабегим, 9/1
        </PublicOfferContent>
        <PublicOfferContent>ИНН: 306628565</PublicOfferContent>
        <PublicOfferContent>ОКЭД: 52230</PublicOfferContent>
        <PublicOfferContent>Р/с: 20208000905109995001 в АКБ «Ипак Йули» Банк г. Ташкент</PublicOfferContent>
        <PublicOfferContent>МФО: 01028</PublicOfferContent>
        <PublicOfferContent>Директор – Тюшагин Владимир Иванович</PublicOfferContent>
      </PublicOfferInfo>
    </Wrapper>
  );
};
